import { getData } from "utils/Gateway";

export const getDateFormatInSpanish = (dateString) => {
  if (dateString) {
    const parts = dateString.split("-");
    if (parts.length < 2) {
      return dateString;
    }
    const formattedDate = `${parts[2]}/${parts[1]}/${parts[0]}`;
    return formattedDate; // Output: 17/10/2018
  }
};

export const getUpdatedConvertedDate = (dateString) => {
  const createdAt = new Date(dateString);

  // Formatting date
  const formattedDate = createdAt.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  // Formatting time
  const formattedTime = createdAt.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
  });

  // Adjusting time format to AM/PM
  const amPmTime = formattedTime.replace(/^(\d{1,2}:\d{2}) (AM|PM)$/, "$1 $2");

  // Combining date and time
  const formattedDateTime = `${formattedDate} at ${amPmTime}`;

  return formattedDateTime; // Output: 05/03/2024 at 01:04 PM
};

export const createdAtToDateConverter = (dateValue) => {
  // Assuming your MongoDB document has a field named 'createdAt' which holds the timestamp
  let createdAtTimestamp = new Date(dateValue); // Example timestamp, replace with your actual timestamp from MongoDB

  // Convert timestamp to dd/mm/yyyy format
  let day = createdAtTimestamp.getDate();
  let month = createdAtTimestamp.getMonth() + 1; // January is 0, so we add 1 to get the correct month
  let year = createdAtTimestamp.getFullYear();

  // Ensure leading zeros if necessary
  day = day < 10 ? "0" + day : day;
  month = month < 10 ? "0" + month : month;

  // Formatted date in dd/mm/yyyy format
  let formattedDate = `${day}/${month}/${year}`;

  return formattedDate;
};

// resize the image and convert to height and width as asked in params
// use for resizing large image to fit into BLOB url
export const resizeOrCompressImage = (imageData, targetWidth, targetHeight) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = function () {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      canvas.width = targetWidth;
      canvas.height = targetHeight;
      ctx.drawImage(img, 0, 0, targetWidth, targetHeight);
      canvas.toBlob(
        function (blob) {
          resolve(blob);
        },
        "image/jpeg",
        0.8 // Set the quality here (0.8 for 80%)
      );
    };

    img.src = imageData;
  });
};

//spanish amount format
export const formatNumber = (number = 0) => {
  return new Intl.NumberFormat("de-DE").format(number);
};

export const getTomorrowDate = () => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const formattedDate = tomorrow.toISOString().split("T")[0];
  return formattedDate;
};

export const getCurrentMonthFirstDate = () => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), 1);
};

export const getMonthOfTheDate = (dateString = "") => {
  if (dateString === "") {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), 1);
  } else {
    const givenDate = new Date(dateString);
    return new Date(givenDate.getFullYear(), givenDate.getMonth(), 1);
  }
};

// input params '2024-12-25'
export const getYearsBetweenDates = (startDate, endDate) => {
  const startYear = new Date(startDate).getFullYear();
  const endYear = new Date(endDate).getFullYear();

  const years = [];
  for (let year = startYear; year <= endYear; year++) {
    years.push(year);
  }
  return years;
};

export const hoursArr = [
  "00",
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
];

export const generateRandomString = (length) => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  const charactersLength = characters.length;

  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
};

/**
 * Calculates Levenshtein distance between two strings
 * @param {string} a - First string
 * @param {string} b - Second string
 * @returns {number} Edit distance between strings
 */
export const levenshtein = (a, b) => {
  if (a.length === 0) return b.length;
  if (b.length === 0) return a.length;

  const matrix = Array(b.length + 1)
    .fill(null)
    .map(() => Array(a.length + 1).fill(null));

  for (let i = 0; i <= b.length; i++) {
    matrix[i][0] = i;
  }

  for (let j = 0; j <= a.length; j++) {
    matrix[0][j] = j;
  }

  for (let i = 1; i <= b.length; i++) {
    for (let j = 1; j <= a.length; j++) {
      const cost = b.charAt(i - 1) === a.charAt(j - 1) ? 0 : 1;
      matrix[i][j] = Math.min(
        matrix[i - 1][j] + 1, // Deletion
        matrix[i][j - 1] + 1, // Insertion
        matrix[i - 1][j - 1] + cost // Substitution
      );
    }
  }

  return matrix[b.length][a.length];
};

// Helper to get file icon
export const getFileIcon = (fileName) => {
  if (/\.(jpg|jpeg|png|gif)$/i.test(fileName)) return "image";
  if (/\.(pdf)$/i.test(fileName)) return "picture_as_pdf";
  if (/\.(doc|docx)$/i.test(fileName)) return "article";
  if (/\.(mp4|mov|avi)$/i.test(fileName)) return "movie";
  return "attach_file";
};

// Helper function to format timestamp and return in dd/mm/yyyy hh:mm:ss format
// If timestamp is not provided, it returns "-"
export const formatTimestamp = (timestamp) => {
  if (!timestamp) return "-";
  const date = new Date(timestamp);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};

/**
 * Update a list by removing items with matching _id
 * and then unshifting (adding to start) the new items.
 *
 * @param {Array} oldList - existing state list
 * @param {Array} newItems - new items to be inserted
 * @returns {Array} updated list
 */
export const updateListByIds = (oldList = [], newItems = []) => {
  if (!Array.isArray(oldList) || !Array.isArray(newItems)) {
    throw new Error("Both oldList and newItems must be arrays");
  }

  // Remove any item from oldList that has same _id in newItems
  const filtered = oldList.filter(
    (item) => !newItems.some((newItem) => newItem._id === item._id)
  );

  // Put new items at the start
  return [...newItems, ...filtered];
};

/**
 * Replace items in oldList if _id matches with newItems.
 * If no match, keep old item as it is.
 *
 * @param {Array} oldList - existing state list
 * @param {Array} newItems - new items to be updated
 * @returns {Array} updated list
 */
export const replaceListByIds = (oldList = [], newItems = []) => {
  if (!Array.isArray(oldList) || !Array.isArray(newItems)) {
    throw new Error("Both oldList and newItems must be arrays");
  }

  // Map for quick lookup of newItems by _id
  const newItemsMap = new Map(newItems.map((item) => [item._id, item]));

  // Replace if found in newItems, else keep old
  return oldList.map((item) => newItemsMap.get(item._id) || item);
};

/**
 * Merge new items into an existing list by matching `_id`.
 *
 * - If `_id` matches → replace the old item with the new one.
 * - If `_id` does not exist → add the new item at the beginning of the list.
 *
 * @param {Array<Object>} prevList - The previous list of items
 * @param {Array<Object>} newData - The new items to merge
 * @returns {Array<Object>} The updated list after merging
 */
export const mergeListById = (prevList, newData) => {
  let updatedList = [...prevList];

  newData.forEach((newItem) => {
    const index = updatedList.findIndex(
      (oldItem) => oldItem._id === newItem._id
    );

    if (index !== -1) {
      // Replace existing item
      updatedList[index] = newItem;
    } else {
      // Insert new item at the beginning
      updatedList.unshift(newItem);
    }
  });

  return updatedList;
};

// Reorder function for drag-and-drop
export const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

// fetch options from api
export const fetchOptions = async (url, setter) => {
  try {
    const data = await getData(url);
    if (data) {
      setter(data.map((item) => ({ value: item.value, label: item.name })));
    } else {
      console.error(`Error fetching data from ${url}:`);
    }
  } catch (error) {
    console.error(`Error fetching data from ${url}:`, error.message);
  }
};
